import React from 'react';
import { Grid } from '@material-ui/core';
import * as lib from '~/dependencies';
import chunk from '~/helpers/chunk';
import { DialPadComponent, ButtonComponent } from './styles';

const keys = [
  { name: 1, letters: '' },
  { name: 2, letters: 'ABC' },
  { name: 3, letters: 'DEF' },
  { name: 4, letters: 'GHI' },
  { name: 5, letters: 'JKL' },
  { name: 6, letters: 'MNO' },
  { name: 7, letters: 'PQRS' },
  { name: 8, letters: 'TUV' },
  { name: 9, letters: 'WXYZ' },
  { name: '*', letters: '' },
  { name: 0, letters: '' },
  { name: '#', letters: '' },
];

export default function DialNumber(props) {
  const { insertByPosition, handleKeyPress } = props;
  const keysValues = chunk(keys, 3);

  return (
    <DialPadComponent>
      {keysValues?.map(e => (
        <Grid key={e.name} container spacing={0}>
          {e.map(el => (
            <Grid key={el.name} item xs sm className="center-numbers">
              <ButtonComponent
                size="small"
                onClick={() => insertByPosition(el.name, 'keypad')}
                onKeyPress={handleKeyPress}>
                <span>{el.name}</span>
                <span>{el.letters}</span>
              </ButtonComponent>
            </Grid>
          ))}
        </Grid>
      ))}
    </DialPadComponent>
  );
}

DialNumber.defaultProps = {
  insertByPosition: () => {},
  handleKeyPress: () => {},
};

DialNumber.propTypes = {
  insertByPosition: lib.PropTypes.func,
  handleKeyPress: lib.PropTypes.func,
};
